import { createAsyncThunk } from "@reduxjs/toolkit";
import { Configuration, UserApi } from "api";
import { getBasePath } from "common/getConfiguration";
import { createErrorObject } from "errors/createErrorObject";
import { ErrorObject } from "errors/errorObject";
import type { RootState } from "app/store";

export const initialAsync = createAsyncThunk<
  { success: boolean },
  void,
  {
    state: RootState;
    // rejectした時の返却値の型
    rejectValue: {
      error: ErrorObject;
    };
  }
>("optin/initialAsync", async (args, thunkApi) => {
  // apiのConfigurationを取得する
  const basePath = getBasePath();
  const config = new Configuration({ basePath });

  try {
    const userApi = new UserApi(config);
    await userApi.putOptin();
    return { success: true };
  } catch (e) {
    const error = createErrorObject(e);
    return thunkApi.rejectWithValue({ error });
  }
});
